module.exports = __webpack_public_path__ + "static/media/jardines04M.169eaf8f.jpg";